import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/images/logo.webp";
const Navbar = () => {
  return (
    <div>
      <div className="bg-light-nav-top">
        <div className="home-navbar">
          <nav className="navbar navbar-expand-lg navbar-light p-0">
            <div className="container">
              <NavLink className="navbar-brand d-flex align-items-end" to="/">
                <img className="logo-img" src={Logo} alt="SMS ZOO ZOO" />
              </NavLink>
              <button
                className="navbar-toggler my-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#main_nav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse justify-content-end lh-lg"
                id="main_nav"
              >
                <ul className="navbar-nav mx-auto p-3 p-md-0">
                  <li className="nav-item">
                    <NavLink className="nav-link " to="/">
                      Home
                    </NavLink>
                  </li>
                  <li className="nav-item d-lg-block d-md-none d-none dropdown ktm-mega-menu">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      onClick={(e) => e.preventDefault()}
                    // data-bs-toggle="dropdown"
                    >
                      Services
                    </a>
                    <div className="dropdown-menu mega-menu p-3">
                      <div className="container mega-menu-inner">
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="">
                              <div className="new-wave">
                                <span>
                                  WhatsApp Services
                                </span>
                                <div className="wave-inner"></div>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/whatsapp_marketing">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>WhatsApp Marketing</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/click_to_whatsappads">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>Click to WhatsApp Ads</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/whatsapp_chatbots">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>WhatsApp Chatbots </span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/whatsapp_business_api">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>WhatsApp Business API</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/whatsapp_bluetick">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>WhatsApp Blue Tick</span>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="">
                              <div className="new-wave wave-card-sms">
                                <span>
                                  SMS Services
                                </span>
                                <div className="wave-inner"></div>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/bulk_sms">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>Bulk SMS</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/rcs_messages">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>RCS SMS</span>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="">
                              <div className="new-wave wave-card-smm">
                                <span>
                                  Social Media
                                  Marketing
                                </span>
                                <div className="wave-inner"></div>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/facebook_instagram_marketing">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>Facebook & Instagram</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/linkedin_ads">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>LinkedIn</span>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="">
                              <div className="new-wave wave-card-dm">
                                <span>
                                  Digital
                                  Marketing
                                </span>
                                <div className="wave-inner"></div>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/search_engine_optimization">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>SEO</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/pay_per_click">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>PPC Campaign</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/google_ads">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>Google Ads</span>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="nav-item d-lg-none d-md-block d-block dropdown ktm-mega-menu">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      data-bs-toggle="dropdown"
                    >
                      Services
                    </a>
                    <div className="dropdown-menu mega-menu">
                      <div className="container mega-menu-inner">
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="mb-4">
                              <div className="new-wave">
                                <span>
                                  WhatsApp Services
                                </span>
                                <div className="wave-inner"></div>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/whatsapp_marketing">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>WhatsApp Marketing</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/click_to_whatsappads">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>Click to WhatsApp Ads</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/whatsapp_chatbots">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>WhatsApp Chatbots </span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/whatsapp_business_api">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>WhatsApp Business API</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/whatsapp_bluetick">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>WhatsApp Blue Tick</span>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="mb-4">
                              <div className="new-wave wave-card-sms">
                                <span>
                                  SMS Services
                                </span>
                                <div className="wave-inner"></div>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/bulk_sms">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>Bulk SMS</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/rcs_messages">
                                  <span>
                                    <i class="arrow fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>RCS SMS</span>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="mb-4">
                              <div className="new-wave wave-card-smm">
                                <span>Social Media Marketing</span>
                                <div className="wave-inner"></div>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/facebook_instagram_marketing">
                                  <span>
                                    <i class="fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>Facebook & Instagram</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/linkedin_ads">
                                  <span>
                                    <i class="fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>LinkedIn </span>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="mb-4">
                              <div className="new-wave wave-card-dm">
                                <span>Digital Marketing</span>
                                <div className="wave-inner"></div>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/search_engine_optimization">
                                  <span>
                                    <i class="fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>SEO</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/pay_per_click">
                                  <span>
                                    <i class="fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>PPC Campaign</span>
                                </NavLink>
                              </div>
                              <div className="tabs ">
                                <NavLink className={"tab"} to="/google_ads">
                                  <span>
                                    <i class="fa-solid fa-arrow-right"></i>
                                  </span>
                                  <span>Google Ads</span>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link " to="/about_us">
                      About Us
                    </NavLink>
                  </li>
                  {/*<li className="nav-item">
                    <NavLink className="nav-link " to="/pricing">
                      Pricing
                    </NavLink>
                  </li>*/}
                  <li className="nav-item">
                    <NavLink className="nav-link " to="/blogs">
                      Blogs
                    </NavLink>
                  </li>
                </ul>
                <div className="d-flex mb-lg-0 mb-md-0 mb-4">
                  <div className="nav-item my-auto">
                    <NavLink className="text-decoration-none" to="/contact_us">
                      <div className="animated-contact-button">
                        <div className="button-text-slide">
                          Contact Us
                        </div>
                        <div className="arrow-section">
                          <i className="fa-solid fa-arrow-right-long"></i>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
